import dynamic from 'next/dynamic'

export const PayOnStepAction = dynamic(() => import('./pay-on-step-action'))
